import React, { PropsWithChildren, useReducer } from "react";
import { initialState, reducer } from './sampleDataReducer';

// Allow in same file
// eslint-disable-next-line
export const SampleDataStateContext = React.createContext(initialState);
// Allow any below
// eslint-disable-next-line
export const SampleDataDispatchContext = React.createContext<React.Dispatch<any>>(() => undefined)

export const SampleDataProvider = ({ children }: PropsWithChildren) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <SampleDataStateContext.Provider value={state}>
            <SampleDataDispatchContext.Provider value={dispatch}>
                {children}
            </SampleDataDispatchContext.Provider>
        </SampleDataStateContext.Provider>
    );
};
